import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import { SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../utils/global_variables';
import { Funds } from '../../Funds';
import { BzToolTip } from '../../../components';

const SideFunds = ({ setIsExpanded, setActiveMenu, setToggleSideContainer, sideContentId, ...props }) => {//BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23



    return (
        <>
            <ContainerHeader>
                <Container fluid className='p-0'>
                    <Row className='g-0 stickysidemenu-top-header bdr-btm mb-2 p-3'>
                        <Col md={9} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text line-height-1 text-uppercase'>FUNDS</div>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-self-center'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                    setToggleSideContainer(false);
                                    setActiveMenu({});
                                    }}>                                
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>                   
                </Container>
            </ContainerHeader>
            <ContainerBody>
                <Funds type={'watchlist'} />
            </ContainerBody>

        </>
    );
};

export default memo(SideFunds);

